export default "__VITE_ASSET__DP3oAGRa__"